import React from 'react';
import { IMG_URL_RE } from './constants';

export default function InlineImageText({ text, maxHeight = 120 }) {
  if (!text) return null;
  const parts = text.split(IMG_URL_RE);
  if (parts.length === 1) return <span style={{ whiteSpace: 'pre-wrap' }}>{text}</span>;
  return (
    <span>
      {parts.map((part, i) => {
        if (IMG_URL_RE.test(part)) {
          return (
            <span key={i} style={{ display: 'block', margin: '6px 0' }}>
              <img
                src={part}
                alt=""
                style={{
                  maxHeight,
                  width: 'auto',
                  maxWidth: '100%',
                  borderRadius: 8,
                  border: '1px solid rgba(255,255,255,0.1)',
                  display: 'block',
                  objectFit: 'contain',
                }}
                onError={e => { e.target.style.display = 'none'; }}
              />
            </span>
          );
        }
        return part ? <span key={i} style={{ whiteSpace: 'pre-wrap' }}>{part}</span> : null;
      })}
    </span>
  );
}
